// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[rangeValidator]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: RangeValidatorDirective,
      multi: true,
    }
  ]
})
export class RangeValidatorDirective implements Validator {
  @Input() min = 0;
  @Input() max = 10000;

  validate(control: AbstractControl): ValidationErrors | null {
    const raw = control.value;
    if (raw === undefined || raw === null || raw === '') {
      return null;
    }
    const str = String(raw);

    const whitespacePattern = /[ \u3000]/;
    if (whitespacePattern.test(str)) {
      return { whitespace: true };
    }

    const numberPattern = /^\d+(\.\d+)?$/;
    if (!numberPattern.test(str)) {
      return { number: true };
    }

    const num = Number(control.value);
    if (Number.isNaN(num)) {
      return { range: true };
    }

    if (num < this.min || num > this.max) {
      return { range: true };
    }

    return null;
  }
}
